var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLikeHeart(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "34px",
    height: "31px",
    viewBox: "0 0 34 31",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "icon") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "heart",
    transform: "translate(0.500000, 0.000000)",
    fill: "#fa7925"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23.3298,0 C21.1583,0 19.7586,0.2587 18.154,1.04411 C17.5599,1.3349 17.0026,1.68509 16.485,2.09364 C15.9873,1.70799 15.4522,1.37388 14.8827,1.0922 C13.247,0.28316 11.7754,0 9.6818,0 C4.07466,0 0,4.6459 0,10.6798 C0,15.2366 2.54075,19.6384 7.27326,23.8948 C9.7573,26.129 12.929,28.34 15.2004,29.5162 L16.5,30.1892 L17.7996,29.5162 C20.071,28.34 23.2427,26.129 25.7267,23.8948 C30.4593,19.6384 33,15.2366 33,10.6798 C33,4.70977 28.8869,0.02304 23.3298,0 Z M30,10.6798 C30,14.2498 27.8793,17.924 23.7206,21.6643 C21.4533,23.7035 18.5385,25.7414 16.5,26.8105 C14.4616,25.7414 11.5468,23.7035 9.2794,21.6643 C5.12076,17.924 3.00003,14.2498 3.00003,10.6798 C3.00003,6.22156 5.82549,2.99999 9.6818,2.99999 C11.3465,2.99999 12.3722,3.19737 13.5527,3.78125 C14.25,4.12614 14.8663,4.58154 15.3998,5.15064 L16.5035,6.32804 L17.5972,5.14131 C18.1427,4.54941 18.768,4.08364 19.4729,3.73862 C20.6188,3.17772 21.5805,2.99999 23.3237,2.99999 C27.1323,3.01578 30,6.28343 30,10.6798 Z",
    id: "icon"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLikeHeart);
export default __webpack_public_path__ + "static/media/likeHeart.349b960f4324857f8deb7c2701a4a16e.svg";
export { ForwardRef as ReactComponent };